<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar toggleable="lg" type="light" variant="mdh">
          <b-navbar-brand>
            <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item href="/home" v-if="authenticated">Dashboard</b-nav-item>
              <b-nav-item href="/certificate-search">Search Certificate</b-nav-item>

              <b-nav-item href="/faq">Frequently Asked Questions</b-nav-item>

              <b-nav-item href="/provider/users" v-if="authenticated && hasRole('provider-admin')">Authorized users</b-nav-item>

              <b-nav-item href="/print-certificate" v-if="authenticated && hasRole('cna')">
                  Print Certificate
              </b-nav-item>

              <b-nav-item-dropdown id="menu_contact" text="My Information"
                                   v-if="authenticated && hasRole('cna')">
                <b-dropdown-item href="/profile-info">View My Information</b-dropdown-item>
                <b-dropdown-item href="/profile-contact-update">Update Contact Information</b-dropdown-item>
                <b-dropdown-item href="/profile-name-update">Update Name</b-dropdown-item>
                <b-dropdown-item href="/profile-ssn-update">Correct SSN</b-dropdown-item>
                <b-dropdown-item href="/profile-dob-update">Correct Date of Birth</b-dropdown-item>
                <b-dropdown-item href="/profile-texting-preferences">Update Texting Preferences</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item-dropdown id="menu_admin" text="Admin"
                                   v-if="authenticated && (hasRole('mdh-admin') || hasRole('mdh-staff'))">
                <b-dropdown-item href="/change-requests">Information Change Requests</b-dropdown-item>
                <b-dropdown-item href="/cna-report">Current CNA Report</b-dropdown-item>
                <b-dropdown-item href="/search-audit" v-if="hasRole('mdh-admin')">Full SSN Search Audit</b-dropdown-item>
                <b-dropdown-item href="/credentialer" v-if="hasRole('mdh-admin')">Credentialer Management</b-dropdown-item>
                <b-dropdown-item href="/credentialer-search" v-if="hasRole('mdh-admin')">Credentialer Search</b-dropdown-item>
                <b-dropdown-item href="/credentialer-reports" v-if="hasRole('mdh-admin')">Credentialer Reports</b-dropdown-item>
                <b-dropdown-item href="/facilityNAReportsAdmin">Facility Staff Reports</b-dropdown-item>
                <b-dropdown-item href="/headmaster">Trigger Headmaster Import</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item href="/announcementEmails" v-if="authenticated && hasRole('mnit-admin')">Trigger announcement emails</b-nav-item>

              <b-nav-item href="/headmaster" v-if="authenticated && hasRole('mnit-admin')">Trigger Headmaster Import</b-nav-item>

              <b-nav-item href="/correct-unclaimed" v-if="authenticated && hasNoRole()">Correct Name, SSN, or DOB</b-nav-item>

              <b-nav-item @click="logout" v-if="authenticated">Log out</b-nav-item>
              <b-nav-item href="/home" v-if="!authenticated">Log in</b-nav-item>
            
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>

    <main id="main-content">
      <b-container fluid>
              <router-view/>
      </b-container>
    </main>

    <footer>
      <div class="mt-5">
        <hr/>
        <div class="fluid-container footer justify-content-center">
          <p class="text-center small">
            <span>
              Nurse Aide Registry Phone Number 651-201-4200 (8:00 am to 4:00 pm Monday through Friday)
            </span><br/>
            <span>
              <b-link href="https://www.health.state.mn.us/nar" target="_blank">
                    Nurse Aide Registry Further Information (opens in new tab)
                </b-link>
            </span><br/>
            <span >
              NAR email: <a href="mailto:HEALTH.FPC-NAR@state.mn.us">health.fpc-nar@state.mn.us</a>
            </span><br/>
            <span>
                 v{{appVersion}}
            </span>
            <span>
                - Last Updated: {{lastModified}}
            </span>

          </p>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
  import LocalStorageService from '@/common/LocalStorageService';
  import {version} from '../package.json';

  export default {
    metaInfo: {
      title: 'Welcome',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    },
    computed: {
      authenticated: function() {
        if (this.$keycloak) {
          return this.$keycloak.authenticated;
        } else {
          return false;
        }
      },
      appVersion: function() {
          return version;
      },
        lastModified: function(){
        var buildTimestamp = new Date(document.documentElement.dataset.buildTimestampUtc);
        var year = buildTimestamp.getFullYear();
        var month = (buildTimestamp.getMonth()+1).toString();
        month = month.length > 1 ? month: '0'+month;
        var day = buildTimestamp.getDate().toString();
        day = day.length > 1 ? day : '0'+day;
        return month+'/'+day+'/'+year;
        }
    },


    methods: {
      logout() {
        const localStorageService = LocalStorageService.getService()
        localStorageService.clearAuthTokens()
        this.$store.dispatch('resetState')
        this.$keycloak.clearToken()
        this.$keycloak.logoutFn()
      },
      hasRole(roles) {
        if (this.$keycloak) {
          return this.$keycloak.hasResourceRole(roles)
        } else {
          return false;
        }
      },
      hasNoRole(){
        if (this.$keycloak) {
          let roles = ['mnit-admin', 'mdh-admin', 'mdh-staff', 'readonly', 'provider-admin', 'provider', 'cna', 'interstate']
          let present;
          roles.forEach(r => {if (this.hasRole(r)) {
            present = true
          }})
          return !present
        }
        return false
      }
    },
  }
</script>

<style lang="scss">

  @import "assets/_custom.scss";
  @import "vue-select/src/scss/vue-select.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1F2E37;
}

h1, .h1 {
  font-size: 30px;
  font-weight: 600;
}

h2, .h2 {
  font-size: 24px;
  font-weight: 600;
}

h3, .h3 {
  font-size: 18px;
  font-weight: 600;
}

button {
  margin-right: 18px;
}

ul {
  list-style-type: none;
  padding: 0;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav  a.dropdown-item {
  color: black !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.colWidth40 {
  width: 40%;
}

.is-invalid .d-block {
    color: #EB0000;
}

.label-required::after {
  color: #0a8927;
  font-size: .7em;
  text-transform: uppercase;
  margin-left: 19px;
  content:" required";

}

.wizard-card-footer div span {
  outline: none;
}

.wizard-card-footer div span:focus button {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
}

.wizard-nav li:has(.disabled) {
  user-focus: none;
 }

 .card {
   margin-bottom: 2em;
 }

  .navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }

  .navbar-light .navbar-toggler {
    border-color: white;
  }

  .navbar-light .navbar-toggler:focus, .navbar-light .navbar-toggler:hover, .navbar-light .navbar-toggler:focus-visible {
    outline: 2px solid #78BE21;
  }

  .sr-caption caption {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .sr-caption caption:active,
  .sr-caption caption:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
  }
  .btn-outline-primary {
    color: #003865;
    border-color: #003865;
  }

  .btn-outline-primary:active, .btn-outline-primary:hover, .btn-primary:not(:disabled):not(.disabled):active,
  .btn-outline-primary:not(:disabled):not(.disabled):active, .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #003865;
    border-color: #003865;
  }

  .wizard-btn, .wizard-btn:hover, .wizard-btn:focus, .btn-primary, .btn-primary:hover, .btn-primary:focus {
    background-color: #003865;
    border-color: #003865;
    color: #ffffff;
    outline-color: #A8D8FF;
  }

  .btn-outline-primary:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
  }

  .btn-outline-primary:disabled {
    color: #003865;
  }

  .green-required::after {
    color: #0a8927;
    font-size: .7em;
    text-transform: uppercase;
    margin-left: 19px;
    content: " required";
    font-weight: 750;
  }

  .btn-success {
    background-color: #208836;
    border-color: #208836;
  }

  .btn-success:focus, .btn-success:hover, .btn-success:focus-visible {
    outline-color: #AADFB5;
  }

  .btn-secondary:focus, .btn-secondary:hover, .btn-secondary:focus-visible {
    outline-color: #CBD0D2;
  }

</style>
